import { ApButtonGroup, ApModal } from '@alixpartners/ui-components';
import { ApButtonCasual, ApButtonMainEx } from 'components/UIComponents/Buttons';
import { InputText } from 'components/UIComponents/InputText';
import { useState } from 'react';
import './DialogCustomEmail.css';

interface Props {
  senderEmailAddress: string;
  initialText: string;
  onClose: () => void;
  onConfirm: (text: string) => void;
}

export const DialogCustomEmail = ({
  initialText,
  senderEmailAddress,
  onClose,
  onConfirm,
}: Props) => {
  const [text, setText] = useState(initialText);

  const handleConfirm = () => {
    onConfirm(text);
    onClose();
  };

  return (
    <ApModal
      className="settlements-custom-email-dialog"
      isDismissible={false}
      isFluid={true}
      isOpen={true}
      zIndex={1200}
      hasClosed={onClose}
      footer={() => (
        <ApButtonGroup justifyContent="space-between">
          <ApButtonCasual onClick={onClose}>Cancel</ApButtonCasual>
          <ApButtonMainEx onClick={handleConfirm}>Add message</ApButtonMainEx>
        </ApButtonGroup>
      )}
    >
      <div className="settlements-custom-email">
        <div className="settlements-custom-email__title">
          You can write a direct message to <b>{senderEmailAddress}</b> using the box
          below. This message is going to be displayed as the first paragraph of the
          email.
        </div>
        <div className="settlements-custom-email__body thin-scrollbar">
          <InputText
            className="settlements-custom-email__input"
            role="input"
            label="Message"
            inputComponent="textarea"
            maxLength={8192}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </div>
      </div>
    </ApModal>
  );
};
